<div class="home-block">
  <!-- <div class="home-block-header">Powered by <b>KANTAR</b></div> -->
  <div class="setting-block-header"></div>

  <div class="setting-icon" *ngIf="settingIconShown">
    <img src="../../../../assets/images/common/Settings Icon.svg" title="setting" alt="setting"
      (click)="OnSettingClick()"  DocumentClick (DocumentClicked)="closeSummary()"/>
    <div class="setting-container" *ngIf="toggleSetting" >

      <!-- (click)="OnExportsDownloads()" -->
      <div class="setting-blocks" *ngIf="exportDownloads" title="Export Downloads" (click)="OnExportsDownloads()">
        <div class="setting-block-icon export-download-icon"></div>
        <div class="setting-block-name">Export Downloads</div>
      </div>
      <div *ngIf="isHelpGuide" class="setting-blocks" title="Help Guide" (click)="onUserGuideClick()">
        <div class="setting-block-icon user-guide"></div>
        <div class="setting-block-name">Help Guide</div>
      </div>

      <div *ngIf="isDocumentRepository" class="setting-blocks"
           title="Document Repository">
        <div class="setting-block-icon doc-repo-icon"></div>
        <div class="setting-block-name">Document Repository</div>
      </div>

      <div class="setting-blocks" title="User Management"
        (click)="onUserManagementClick()">
        <div class="setting-block-icon user-management-icon"></div>
        <div class="setting-block-name">User Management</div>
      </div>

      <div class="setting-blocks" title="Log out" (click)="LogOut()">
        <div class="setting-block-icon logout-icon"></div>
        <div class="setting-block-name">Log out</div>
      </div>
    </div>
  </div>

  <div class="home-icon" title="Home" (click)="redirectToLandingPage()">
    <img src="../../../../assets/images/common/Home Icon.svg" alt="Home">
  </div>
</div>

<app-export-downloads-popup (closePopup)="onCloseExportDownloads()" [showExportsDownloads]="showExportsDownloadsPopup" *ngIf="showExportsDownloadsPopup" [ReportInput]="exportReportInput"></app-export-downloads-popup>
